module.exports = __webpack_public_path__ + "static/media/code.e9aec746.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/code.png
// module id = 1041
// module chunks = 0